var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "toggle",
      attrs: { "data-tooltip": _vm.i18n[_vm.i18nKey][_vm.filter.key] }
    },
    [
      _c("input", {
        attrs: {
          type: "checkbox",
          id: "filter-" + _vm.i18nKey + "-" + _vm.filter.key
        },
        domProps: { checked: _vm.filter.active },
        on: { change: _vm.updateFilter }
      }),
      _vm._v(" "),
      _c(
        "label",
        { attrs: { for: "filter-" + _vm.i18nKey + "-" + _vm.filter.key } },
        [_c("span", { class: [_vm.baseIconStyle, _vm.filter.key] })]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1bcafd8f", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1bcafd8f","hasScoped":false,"optionsId":"1","buble":{"transforms":{}}}!./src/components/filters/filter-toggle/filter-toggle.html
// module id = 142
// module chunks = 0